import React, { useEffect, useRef } from 'react'
import type { User } from '@src/stores/auth/user'
import { useIsMobile } from '@src/hooks'
import { MobileView } from './AppTop.mobile'
import { DesktopView } from './AppTop.desktop'
import { isUserLoggedIn } from '@src/utils/functions'
import { HeaderContainer } from './AppTop.styled'

const AppTop: React.FC<{ user: User }> = ({ user }) => {
  const isLoggedIn = isUserLoggedIn()
  const isMobile = useIsMobile()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const observer = new ResizeObserver(() => {
      const height = element.getBoundingClientRect().height
      document.documentElement.style.setProperty('--header-h', `${height}px`)
    })

    observer.observe(element)

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <HeaderContainer ref={ref} id="app-header">
      {isMobile ? (
        <MobileView user={user} isLoggedIn={isLoggedIn} />
      ) : (
        <DesktopView user={user} isLoggedIn={isLoggedIn} />
      )}
    </HeaderContainer>
  )
}

export default AppTop
